import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { TestId } from '../../enums/test';
import { Message } from '../Message/index.types';
import Timestamp from './Timestamp';

type Props = PropsWithChildren & {
    actorName: string;
    className?: string;
    timestamp?: Message['createdAt'];
};

function BotBubble({ actorName, className, timestamp, children }: Props) {
    if (!children) return null;

    return (
        <div
            className={clsx(
                'flex flex-col gap-5 p-15 w-fit max-w-full bg-charcoal-40 rounded-r-20 rounded-l-5',
                'first-of-type:rounded-tl-20 [&:first-of-type_.bubble-header]:flex',
                className,
            )}
            data-testid={TestId.BOT_BUBBLE}
        >
            <div className='bubble-header hidden gap-20 justify-between items-center'>
                <Typography variant='body-md' fontWeight='medium' data-testid={TestId.ACTOR_NAME}>
                    {actorName}
                </Typography>
                {timestamp && <Timestamp timestamp={timestamp} />}
            </div>
            {children}
        </div>
    );
}

export default BotBubble;
